// Returns "row N, M" style description of duplicated values (rows numbered as in the spreadsheet)
export function findDuplicateRows(rows, keyFn) {
  const seen = new Map();
  rows.forEach((r, i) => {
    const k = keyFn(r);
    if (!k) return;
    seen.set(k, [...(seen.get(k) || []), i + 2]);
  });
  return [...seen.entries()].filter(([, idx]) => idx.length > 1).map(([k, idx]) => `${k} (${idx.join(", ")})`);
}

export const normVat = (v) => String(v || "").trim().toUpperCase().replace(/\s/g, "");
